import { COOKIE_KEY, SESSION_QUERY_PASSTHROUGH } from '~/constants/config';
import { getLocation, postUploadBehavior } from '~/api/module/seo';
import { getChannel } from '@youyan/common';

export enum UNIQ_BEHAVIOR {
  CLICK_SUBSCRIBE = '/subscribe/click', // 点击订阅
}

// BI 埋点
let persistCountry: string | undefined;
export async function trackUploadBehavior(behavior: string | UNIQ_BEHAVIOR) {
  if (import.meta.client) {
    const runtimeConfig = useRuntimeConfig();
    const { isMobile } = useDevice();

    // 同步埋点数据到bi所需随机用户id
    if (!getCookie(COOKIE_KEY.USER_RANDOM_ID) && !runtimeConfig.public.privatization) {
      const fingerprint = await getFingerprint();
      setCookie(COOKIE_KEY.USER_RANDOM_ID, fingerprint);
    }
    // 只上报一次
    const {
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
      from,
      ref,
      keyword_search,
    } = sessionGetItem(SESSION_QUERY_PASSTHROUGH) || {};
    const session_id = getCookie(COOKIE_KEY.USER_RANDOM_ID);
    const country = persistCountry || (await getLocation()).country;

    postUploadBehavior({
      behavior,
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
      session_id,
      country,
      keyword_search,
      gclid: getChannel().gclid,
      source: from || ref,
      platform: isMobile ? 'mobile' : 'pc',
    });
  }
}
